export const types = {
  SET_COEF_TYPE: 'SET_COEF_TYPE'
};
